import { render } from "./MyCarousel.vue?vue&type=template&id=68e6cc0c&scoped=true"
import script from "./MyCarousel.vue?vue&type=script&lang=js"
export * from "./MyCarousel.vue?vue&type=script&lang=js"

import "./MyCarousel.vue?vue&type=style&index=0&id=68e6cc0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e6cc0c"]])

export default __exports__